import styled from 'styled-components';
import { spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';

export const ButtonContainer = styled.div`
  display: flex;
  gap: ${spacing.quarter};
`;

export const TextWrapper = styled.div`
  display: grid;
  grid-template-columns: ${pxToRem(88)} 1fr;
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.base};
`;

export const ButtonContentWrapper = styled.div`
  display: flex;
  gap: ${spacing.half};
  align-items: center;
`;
